import { render, staticRenderFns } from "./terminalConfiguration.vue?vue&type=template&id=21341d30"
import script from "./terminalConfiguration.vue?vue&type=script&lang=js"
export * from "./terminalConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports